import {
  Avatar,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Popover,
  ThemeOptions,
} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { lightTokens } from 'wisestep-base';

const avatarSize = 28;

export const RecruiterAvatarSurplus = ({ list, skip, ...props }) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const surplus = list?.length - skip;

  return (
    <ThemeProvider theme={() => createTheme(lightTokens as ThemeOptions)}>
      {list?.length > skip && (
        <Avatar
          {...props}
          onClick={handleClick}
          sx={{
            ...props.sx,
            cursor: 'pointer',
            bgcolor: '#CAF0F8',
            color: 'common.black',
            height: avatarSize,
            width: avatarSize,
            fontSize: surplus < 100 ? avatarSize / 2 : 10,
          }}
        >
          +{list?.length - skip}
        </Avatar>
      )}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <List>
          {list
            ?.filter((e, i) => i >= skip)
            .map((listItem, i) => (
              <ListItem key={i} disablePadding>
                <ListItemButton {...(listItem.url && { onClick: () => navigate(listItem.url) })}>
                  <ListItemText primary={listItem.name} />
                </ListItemButton>
              </ListItem>
            ))}
        </List>
      </Popover>
    </ThemeProvider>
  );
};
